import { OauthResultViewComponent } from 'account-hybrid/common/components/oauth-result-view/oauth-result-view.component';
// WS4 inc 5 (Track A): the native Angular redirect states replacing the AngularJS global
// redirect states (curation-all / feedback-all / recommendation / invitation), ported off
// account-v2/.../global/states/*.state.config.ts. Pure-redirect zero-UI leaves.
import {
    CurationAllRedirectComponent,
    FeedbackAllRedirectComponent,
    RecommendationRedirectComponent,
    InvitationRedirectComponent,
    TimelineRedirectComponent,
    CurateGuestRedirectComponent,
    HomeRedirectComponent,
} from '../common/components/global-redirect/global-redirect.components';

const loadAuthChildren = () => import('../features/authentication/authentication.module').then(mod => mod.AuthenticationModule);

export const GLOBAL_STATES = [
    {
        name: 'curation-all',
        url: '/{propertySlug}/curation/{companyCode:[\\d\\w]{2}}',
        data: { requiresAuth: true },
        component: CurationAllRedirectComponent
    },
    {
        name: 'feedback-all',
        url: '/{propertySlug}/feedback/{companyCode:[\\d\\w]{2}}',
        data: { requiresAuth: true },
        component: FeedbackAllRedirectComponent
    },
    {
        name: 'recommendation',
        url: '/recommendation/{companyCode:[\\d\\w]{2}}/{propertySlug}/{recommendationUUID:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}}',
        data: { requiresAuth: true },
        component: RecommendationRedirectComponent
    },
    {
        name: 'invitation',
        url: '/invitation/{companyCode:[\\d\\w]{2}}',
        data: { requiresAuth: true },
        component: InvitationRedirectComponent
    },
    {
        name: 'timeline',
        url: '/timeline/{companyCode:[\\d\\w]{2}}/{guestUUID:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}}',
        data: { requiresAuth: true },
        component: TimelineRedirectComponent
    },
    {
        name: 'curate-guest',
        url: '/curation/{companyCode:[\\d\\w]{2}}/{guestUUID:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}}',
        data: { requiresAuth: true },
        component: CurateGuestRedirectComponent
    },
    {
        name: 'home',
        url: '/home?redirectTo',
        data: { requiresAuth: true },
        component: HomeRedirectComponent
    },
    {
        name: 'sign-in.**',
        url: '/sign-in',

        loadChildren: loadAuthChildren
    },
    {
        name: 'recover-password.**',
        url: '/recover-password',
        loadChildren: loadAuthChildren
    },
    {
        name: 'change-password.**',
        url: '/change-password',
        loadChildren: loadAuthChildren
    },
    {
        name: 'create-password.**',
        url: '/create-password',
        loadChildren: loadAuthChildren
    },
    {
        name: 'profile.**',
        url: '/profile',
        loadChildren: loadAuthChildren
    }
];


export const ADMIN_STATES = [
    {
        name: 'admin-area.**',
        url: '/admin-area',
        loadChildren: () => import('../features/admin-area/admin-area.module').then(mod => mod.AdminAreaModule)
    }
];
export const PROPERTY_SPACE_STATES = [
    // `advocacy.**` globs the 15 states AdvocacyGroupModule registers via
    // UIRouterModule.forChild — all dot-separated, so the glob reaches every
    // descendant (`advocacy.contests.details` &c). Deliberately carries no `data`
    // block, matching stories.**/discovery.**/hub.**: the real requiredPermissions
    // live on the state inside the lazy module and the guards re-run on the retry
    // transition after the chunk resolves.
    {
        name: 'advocacy.**',
        url: '/{type:\\w}/{slug}/advocacy',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/advocacy-group/advocacy-group.module').then(mod => mod.AdvocacyGroupModule)
    },
    {
        name: 'advocacy-new.**',
        url: '/{type:\\w}/{slug}/advocacy-new',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/advocacy/advocacy.module').then(mod => mod.AdvocacyModule)
    },
    {
        name: 'stories.**',
        url: '/{type:\\w}/{slug}/stories',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/stories/stories.module').then(mod => mod.StoriesModule)
    },
    {
        name: 'discovery.**',
        url: '/{type:\\w}/{slug}/discovery',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/discovery/discovery.module').then(mod => mod.DiscoveryModule)
    },
    {
        name: 'mission-control.**',
        url: '/{type:\\w}/{slug}/mission-control',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/mission-control/mission-control.module').then(mod => mod.MissionControlModule)
    },
    {
        name: 'reports.**',
        url: '/{type:\\w}/{slug}/reports',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/reports/reports.module').then(mod => mod.ReportsModule)
    },
    {
        name: 'incentives.**',
        url: '/{type:\\w}/{slug}/incentives',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/incentives/incentives.module').then(mod => mod.IncentivesModule)
    },
    {
        name: 'hub.**',
        url: '/{type:\\w}/{slug}',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/hub/hub.module').then(mod => mod.HubModule)
    },
    {
        name: 'experiences.**',
        url: '/{type:\\w}/{slug}/experiences',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        data: {
            isFliptoStaff: true,
        },
        loadChildren: () => import('../features/experiences/experiences.module').then(mod => mod.ExperiencesModule)
    },
    {
        name: 'spacetime.**',
        url: '/{type:\\w}/{slug}/spacetime',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        // webpackPrefetch emits a <link rel="prefetch"> as soon as the main bundle runs, so the
        // browser pulls this chunk at idle priority in parallel with bootstrap instead of starting the
        // download only once the route matches — on a cold load that download was fully serialized
        // behind bootstrap. Prefetch only warms the HTTP cache; the chunk is still evaluated when
        // loadChildren asks for it, so module evaluation order is unchanged, and the later real
        // request is served from the prefetch cache rather than downloaded twice.
        //
        // The tradeoff: this file ships in the entry chunk, so the hint fires on every account
        // document load — sign-in included, and tenants without a Spacetime licence, who never
        // execute this chunk. Accepted because prefetch is idle/lowest priority, never blocks
        // bootstrap, and is HTTP-cached per deploy rather than per navigation. It cannot be gated on
        // licence or route: the magic comment is resolved at build time. Do NOT swap it for
        // webpackPreload — same eager placement but high priority, i.e. on every page's critical path.
        loadChildren: () => import(/* webpackPrefetch: true */ '../features/spacetime/spacetime.module').then(mod => mod.SpacetimeModule)
    },
    {
        name: 'privacy-requests.**',
        url: '/{type:\\w}/{slug}/privacy-requests',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/privacy-requests/privacy-requests.module').then(mod => mod.PrivacyRequestsModule)
    },
    {
        name: 'third-party-integrations',
        url: '/{type:\\w}/{slug}/third-party-integrations/oauth?batch&propertyUuid&companyUuid&result&error&errorMessage',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        component: OauthResultViewComponent
    }
];
export const MIXED_SPACE_STATES = [
    {
        name: 'advocacy.**',
        url: '/{type:\\w}/{slug}/advocacy',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/advocacy-group/advocacy-group.module').then(mod => mod.AdvocacyGroupModule)
    },
    {
        name: 'advocacy-new.**',
        url: '/{type:\\w}/{slug}/advocacy-new',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/advocacy/advocacy.module').then(mod => mod.AdvocacyModule)
    },
    {
        name: 'stories.**',
        url: '/{type:\\w}/{slug}/stories',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/stories/stories.module').then(mod => mod.StoriesModule)
    },
    {
        name: 'discovery.**',
        url: '/{type:\\w}/{slug}/discovery',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/discovery/discovery.module').then(mod => mod.DiscoveryModule)
    },
    {
        name: 'account-settings.**',
        url: '/{type:\\w}/{slug}/account-settings',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/account-settings/account-settings.module').then(mod => mod.AccountSettingsModule)
    },
    {
        name: 'team.**',
        url: '/{type:\\w}/{slug}/team',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/team/team.module').then(mod => mod.TeamModule)
    },
    {
        name: 'mission-control.**',
        url: '/{type:\\w}/{slug}/mission-control',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/mission-control/mission-control.module').then(mod => mod.MissionControlModule)
    },
    {
        name: 'reports.**',
        url: '/{type:\\w}/{slug}/reports',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/reports/reports.module').then(mod => mod.ReportsModule)
    },
    {
        name: 'incentives.**',
        url: '/{type:\\w}/{slug}/incentives',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/incentives/incentives.module').then(mod => mod.IncentivesModule)
    },
    {
        name: 'hub.**',
        url: '/{type:\\w}/{slug}',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/hub/hub.module').then(mod => mod.HubModule)
    },
    {
        name: 'experiences.**',
        url: '/{type:\\w}/{slug}/experiences',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        data: {
            isFliptoStaff: true,
        },
        loadChildren: () => import('../features/experiences/experiences.module').then(mod => mod.ExperiencesModule)
    },
    {
        name: 'domains.**',
        url: '/{type:\\w}/{slug}/domains',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/domains/domains.module').then(mod => mod.DomainsModule)
    },
    {
        name: 'spacetime.**',
        url: '/{type:\\w}/{slug}/spacetime',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        // webpackPrefetch emits a <link rel="prefetch"> as soon as the main bundle runs, so the
        // browser pulls this chunk at idle priority in parallel with bootstrap instead of starting the
        // download only once the route matches — on a cold load that download was fully serialized
        // behind bootstrap. Prefetch only warms the HTTP cache; the chunk is still evaluated when
        // loadChildren asks for it, so module evaluation order is unchanged, and the later real
        // request is served from the prefetch cache rather than downloaded twice.
        //
        // The tradeoff: this file ships in the entry chunk, so the hint fires on every account
        // document load — sign-in included, and tenants without a Spacetime licence, who never
        // execute this chunk. Accepted because prefetch is idle/lowest priority, never blocks
        // bootstrap, and is HTTP-cached per deploy rather than per navigation. It cannot be gated on
        // licence or route: the magic comment is resolved at build time. Do NOT swap it for
        // webpackPreload — same eager placement but high priority, i.e. on every page's critical path.
        loadChildren: () => import(/* webpackPrefetch: true */ '../features/spacetime/spacetime.module').then(mod => mod.SpacetimeModule)
    },
    {
        name: 'privacy-requests.**',
        url: '/{type:\\w}/{slug}/privacy-requests',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/privacy-requests/privacy-requests.module').then(mod => mod.PrivacyRequestsModule)
    },
    {
        name: 'third-party-integrations',
        url: '/{type:\\w}/{slug}/third-party-integrations/oauth?batch&propertyUuid&companyUuid&result&error&errorMessage',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        component: OauthResultViewComponent
    }
];
export const COMPANY_SPACE_STATES = [
    // Carries `params` even though the sibling advocacy-new.** below does not — that
    // omission is a pre-existing inconsistency with its PROPERTY/MIXED twins, not a
    // pattern to copy: without it the dynamic space-switch reloads the state.
    {
        name: 'advocacy.**',
        url: '/{type:\\w}/{slug}/advocacy',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/advocacy-group/advocacy-group.module').then(mod => mod.AdvocacyGroupModule)
    },
    {
        name: 'advocacy-new.**',
        url: '/{type:\\w}/{slug}/advocacy-new',
        loadChildren: () => import('../features/advocacy/advocacy.module').then(mod => mod.AdvocacyModule)
    },
    {
        name: 'stories.**',
        url: '/{type:\\w}/{slug}/stories',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/stories/stories.module').then(mod => mod.StoriesModule)
    },
    {
        name: 'reports.**',
        url: '/{type:\\w}/{slug}/reports',
        loadChildren: () => import('../features/reports/reports.module').then(mod => mod.ReportsModule),
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
    },
    {
        name: 'discovery.**',
        url: '/{type:\\w}/{slug}/discovery',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/discovery/discovery.module').then(mod => mod.DiscoveryModule)
    },
    {
        name: 'account-settings.**',
        url: '/{type:\\w}/{slug}/account-settings',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/account-settings/account-settings.module').then(mod => mod.AccountSettingsModule)
    },
    {
        name: 'team.**',
        url: '/{type:\\w}/{slug}/team',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/team/team.module').then(mod => mod.TeamModule)
    },
    {
        name: 'hub.**',
        url: '/{type:\\w}/{slug}',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/hub/hub.module').then(mod => mod.HubModule)
    },
    {
        name: 'domains.**',
        url: '/{type:\\w}/{slug}/domains',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/domains/domains.module').then(mod => mod.DomainsModule)
    },
    {
        name: 'spacetime.**',
        url: '/{type:\\w}/{slug}/spacetime',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        // webpackPrefetch emits a <link rel="prefetch"> as soon as the main bundle runs, so the
        // browser pulls this chunk at idle priority in parallel with bootstrap instead of starting the
        // download only once the route matches — on a cold load that download was fully serialized
        // behind bootstrap. Prefetch only warms the HTTP cache; the chunk is still evaluated when
        // loadChildren asks for it, so module evaluation order is unchanged, and the later real
        // request is served from the prefetch cache rather than downloaded twice.
        //
        // The tradeoff: this file ships in the entry chunk, so the hint fires on every account
        // document load — sign-in included, and tenants without a Spacetime licence, who never
        // execute this chunk. Accepted because prefetch is idle/lowest priority, never blocks
        // bootstrap, and is HTTP-cached per deploy rather than per navigation. It cannot be gated on
        // licence or route: the magic comment is resolved at build time. Do NOT swap it for
        // webpackPreload — same eager placement but high priority, i.e. on every page's critical path.
        loadChildren: () => import(/* webpackPrefetch: true */ '../features/spacetime/spacetime.module').then(mod => mod.SpacetimeModule)
    },
    {
        name: 'privacy-requests.**',
        url: '/{type:\\w}/{slug}/privacy-requests',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/privacy-requests/privacy-requests.module').then(mod => mod.PrivacyRequestsModule)
    },
    {
        name: 'third-party-integrations',
        url: '/{type:\\w}/{slug}/third-party-integrations/oauth?batch&propertyUuid&companyUuid&result&error&errorMessage',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        component: OauthResultViewComponent
    }
];
export const COLLABORATIVE_COMPANY_SPACE_STATES = [
    {
        name: 'collaborative.**',
        url: '/{type:\\w}/{slug}',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/collaborative/collaborative.module').then(mod => mod.CollaborativeModule)
    },
    {
        name: 'account-settings.**',
        url: '/{type:\\w}/{slug}/account-settings',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/account-settings/account-settings.module').then(mod => mod.AccountSettingsModule)
    },
    {
        name: 'team.**',
        url: '/{type:\\w}/{slug}/team',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/team/team.module').then(mod => mod.TeamModule)
    },
    {
        name: 'members.**',
        url: '/{type:\\w}/{slug}/members',
        params: {
            type: { dynamic: true },
            slug: { dynamic: true }
        },
        loadChildren: () => import('../features/members/members.module').then(mod => mod.MembersModule)
    }
];
